module.exports = __webpack_public_path__ + "img/smc-logo-white.25c299de.svg";